import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { ComoTransaction } from './models/como-transaction';
import { UserIdCode } from './models/user-id-code';
import { ComoReward } from './models/como-reward';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';

@Injectable({
	providedIn: 'root',
})
export class ComoApiService {
	COMO_SERVICE_KEY = '/v1/como';

	private http = inject(HttpClient);
	constructor() {}

	userId(venue: string, email: string) {
		return lastValueFrom(
			this.http.post<UserIdCode>(this.COMO_SERVICE_KEY + '/get-identification-code', {
				venue,
				customer: { email },
			})
		);
	}

	async memberDetails(venue: string, email: string): Promise<any> {
		const res: any = await lastValueFrom(
			this.http.post(this.COMO_SERVICE_KEY + '/member-details', {
				venue,
				customer: { email },
			})
		);

		const data = res.membership;
		data.pointsBalance.balance.nonMonetary = data.pointsBalance.balance.nonMonetary / 100;
		data.pointsBalance.balance.monetary = data.pointsBalance.balance.monetary / 100;
		data.creditBalance.balance.nonMonetary = data.creditBalance.balance.nonMonetary / 100;
		data.creditBalance.balance.monetary = data.creditBalance.balance.monetary / 100;
		data.collectedPoints = res.collectedPoints / 100;
		return data; //todo: create separate class with constructor for this data
	}

	gifts(venue: string, email: string) {
		return lastValueFrom(
			this.http.post<{ gifts: ComoReward[] }>(this.COMO_SERVICE_KEY + '/gifts', {
				venue,
				customer: { email },
			})
		);
	}

	transactions(venue: string, email: string) {
		return lastValueFrom(
			this.http.post<{ transactions: ComoTransaction[] }>(this.COMO_SERVICE_KEY + '/transactions?type=points', {
				venue,
				customer: { email },
			})
		);
	}

	purchases(venue: string, email: string) {
		return lastValueFrom(
			this.http.post(this.COMO_SERVICE_KEY + '/purchases', {
				venue,
				customer: { email },
				limit: '20',
				from: '2026-01-01T00:00:00.000Z',
				to: '2026-03-15T23:59:59.999Z',
			})
		);
	}

	deals(venue: string): Promise<any> {
		return lastValueFrom(this.http.get(this.COMO_SERVICE_KEY + `/deals?venue=${venue}`));
	}

	pointShop(venue: string) {
		return lastValueFrom(
			this.http.get<{
				items: ComoReward[];
			}>(this.COMO_SERVICE_KEY + `/point-shop?venue=${venue}`)
		);
	}

	consent(venue: string, email: string) {
		return lastValueFrom(
			this.http.post(this.COMO_SERVICE_KEY + '/consent', {
				venue,
				customer: { email },
			})
		);
	}

	async verifyIdCode(venue: string, email: string, code: string) {
		return lastValueFrom(
			this.http.post(environment.baseUrl + this.COMO_SERVICE_KEY + '/verify-identification-code', {
				venue,
				customer: { email },
				code,
			})
		).catch(err => null);
	}
}
